/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_Group_HowInputs */

const en_why_listening_compare_group_how = /** @type {(inputs: Why_Listening_Compare_Group_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it reads`)
};

const es_why_listening_compare_group_how = /** @type {(inputs: Why_Listening_Compare_Group_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo lee`)
};

/**
* | output |
* | --- |
* | "How it reads" |
*
* @param {Why_Listening_Compare_Group_HowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_group_how = /** @type {((inputs?: Why_Listening_Compare_Group_HowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_Group_HowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_group_how(inputs)
	return en_why_listening_compare_group_how(inputs)
});